import Vue from 'vue'
import Router from 'vue-router'
const Login = () => import('../components/pages/Login.vue')
const Academy = () => import('../components/pages/Academy.vue')
const Services = () => import('../components/pages/Services.vue')
const Contact = () => import('../components/pages/Contact.vue')
const FAQs = () => import('../components/pages/FAQs.vue')

Vue.use(Router)

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Sports Data Solutions | Sports Technology, Data & Analytics | Consultancy & Academy',
      metaTags: [
        {
          name: 'description',
          content: 'We are a data and software consultancy that specialise in designing and developing bespoke solutions for some of the best high performance sports teams and organisations around the world. We also have our own online code academy that runs fully felxible and immersive courses in data analytics and software development, all via the medium of sport!'
        }
      ]
    }
  },
  {
    path: '/academy',
    name: 'Academy',
    component: Academy,
    meta: {
      title: 'Learn To Code | Data Analytics in Sport | by Sports Data Solutions',
      metaTags: [
        {
          name: 'description',
          content: 'Learn to code, become a data analyst or software developer, all via the medium of sport. Online coding bootcamp for sports and performance professionals or enthusiasts.'
        }
      ]
    }
  },
  {
    path: '/services',
    name: 'Services',
    component: Services,
    meta: {
      title: 'Bespoke Software Development | Progressive Web Apps & AI | by Sports Data Solutions',
      metaTags: [
        {
          name: 'description',
          content: 'We design and develop bespoke web, mobile, progressive web app and AI solutions for teams and organisations in high performance sport. We also provide expert services in data collection, analytics and visualisation.'
        }
      ]
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      title: 'Contact Us | Sports Data Solutions',
      metaTags: [
        {
          name: 'description',
          content: 'If you have any questions or would like to book a call, feel free to contact us on this page.'
        }
      ]
    }
  },
  {
    path: '/faqs',
    name: 'FAQs',
    component: FAQs,
    meta: {
      title: 'FAQs | Learn To Code | by Sports Data Solutions',
      metaTags: [
        {
          name: 'description',
          content: 'FAQs for our online data analytics and software development courses. Either use our resources and community to teach yourself, or go all in with a dedicated mentor.'
        }
      ]
    }
  }
]

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 130 },
        behavior: 'smooth'
      }
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)

  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta')

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key])
    })

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '')

    return tag
  }).forEach(tag => document.head.appendChild(tag))

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js